var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h-tour-dialog',{model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('p',{staticClass:"text-center text-h6 mx-6",domProps:{"textContent":_vm._s(_vm.__('tour0'))}}),_vm._v(" "),_c('div',{staticClass:"my-6 text-center"},[_c('v-icon',{attrs:{"x-large":""},domProps:{"textContent":_vm._s(_vm.icons.tap)}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }